export const CIRCLE_COLORS = ['#1F4B99', '#578FA1', '#BACBA1', '#F2BE75', '#CD7534', '#9E2B0E'];
export const DEFAULT_CIRCLE_COLOR = '#006699';
